<script lang="ts">
  import { Col } from "sveltestrap";

</script>
<Col sm="6">
    <div class="text-md-end text-xs-center">
        <h3>{'Invoice #'}<span class="digits counter">{'1069'}</span></h3>
        <p>{'Issued: May'}<span class="digits"> {'27, 2015'}</span><br>{'Payment Due: June'} <span class="digits">{'27, 2015'}</span></p>
    </div>
</Col>